import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class EventService {

  transactionEventAdded = new EventEmitter();
  salesEventAdded = new EventEmitter();
  ticketEventAdded = new EventEmitter();
  stockEventAdded = new EventEmitter();
  changeSettingEvantAdd = new EventEmitter();

  constructor() {
  }

  onAddEvent(event) {
    this.transactionEventAdded.emit(event);
  }
 onSalesAddEvent(event) {
    this.salesEventAdded.emit(event);
  }

  onResponseTicket(event) {
    this.ticketEventAdded.emit(event);
  }

  onResponseStock(event) {
    this.stockEventAdded.emit(event);
  }

  onResponseSetting(event) {
    this.changeSettingEvantAdd.emit(event);
  }

}
